<template>
  <b-dropdown
    :id="id"
    :text="text"
    :size="setSize"
    :disabled="disabled"
    :style="disabledCursor()"
    :menu-class="$style.limiter"
    class="base-dropdown-wrapper"
    no-flip
    alignment
  >
    <slot />
  </b-dropdown>
</template>

<script>
import cssVars from 'css-vars-ponyfill'

export default {
  props: {
    id: { type: String, required: true },
    text: { type: String, required: true },
    alignment: {
      type: String,
      required: false,
      default: 'right',
    },
    setSize: {
      type: String,
      required: false,
      default: 'md',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    noFlip: {
      type: Boolean,
      required: false,
      default: false,
    },
    selected: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      selectedValue: '',
    }
  },

  computed: {
    cursorType() {
      if (this.disabled) {
        return 'not-allowed'
      }
      return 'default'
    },
  },

  watch: {
    selected(value) {
      this.selectedValue = value
    },
  },

  $_veeValidate: {
    // fetch the current value from the selectedValue defined in the component data.
    value() {
      return this.selectedValue
    },
  },

  methods: {
    disabledCursor() {
      const style = { '--cursor': this.cursorType }
      if (this.disabled) style.cursor = 'not-allowed'
      cssVars({
        onlyLegacy: true,
        variables: {
          '--cursor': this.cursorType,
        },
      })
      return style
    },
  },
}
</script>

<style module>
.limiter {
  max-height: 15.75rem;
  overflow: auto;
}
</style>

<style lang="scss">
.base-dropdown-wrapper {
  .btn {
    cursor: var(--cursor);
  }

  background: #fff;
  border: 0.0625rem solid #ccc;
  .btn-secondary {
    font-size: 0.875rem !important;
    color: #555;
    background: #fff !important;
    border: none !important;
  }

  .dropdown-menu {
    left: -0.75rem !important;
    margin: 0 !important;
    background: #fff !important;
    border-radius: 0.0625rem !important;
    .dropdown-item.active,
    .dropdown-item:active {
      color: #444 !important;
      background: #e6e6e6 !important;
    }
  }
  .dropdown-toggle::after {
    position: relative;
    top: 0.5rem;
    right: -0.625rem;
    float: right;
    color: #555 !important;
  }
}
</style>
